import {
  Paper,
  Typography,
  Box,
  Autocomplete,
  TextField,
  Chip,
  FormControl,
  Button,
  FormHelperText,
  FormControlLabel,
  Checkbox,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

const AddRecipientForm = ({
  value,
  onChange,
  onAdd,
  error,
  includeDownline,
  onIncludeDownlineChange,
}) => {
  const MAX_EMAILS = 20;

  // Parse the value string into an array of emails
  const emails = value
    ? value
        .split(',')
        .map((e) => e.trim())
        .filter((e) => e)
    : [];

  const handleChange = (event, newValue) => {
    // Limit to max emails
    if (newValue.length <= MAX_EMAILS) {
      // Convert array back to comma-separated string
      const newValueStr = newValue.join(', ');
      onChange({ target: { value: newValueStr } });
    }
  };

  const handleAdd = () => {
    // Only call onAdd if there are emails
    if (emails.length > 0) {
      onAdd();
    }
  };

  return (
    <Paper sx={{ p: 2, mb: 3 }}>
      <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        Add New Recipients
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          gap: 2,
          alignItems: 'flex-start',
        }}
      >
        <FormControl fullWidth error={!!error}>
          <Autocomplete
            multiple
            freeSolo
            options={[]}
            value={emails}
            onChange={handleChange}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip variant="outlined" label={option} size="small" {...getTagProps({ index })} />
              ))
            }
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label="Email Addresses"
                placeholder={emails.length === 0 ? 'Type emails and press Enter' : ''}
                size="small"
                error={!!error}
              />
            )}
            disabled={emails.length >= MAX_EMAILS}
          />
          {error && <FormHelperText>{error}</FormHelperText>}
          {!error && emails.length > 0 && (
            <FormHelperText>{`${emails.length}/${MAX_EMAILS} emails`}</FormHelperText>
          )}
          <FormControlLabel
            control={
              <Checkbox
                checked={includeDownline}
                onChange={(e) => onIncludeDownlineChange(e.target.checked)}
                size="small"
              />
            }
            label="Apply to all Producer IDs"
            labelPlacement="start"
            slotProps={{
              typography: {
                variant: 'subtitle1',
              },
            }}
            sx={{ mt: 1 }}
          />
        </FormControl>
        <Button
          variant="outlined"
          onClick={handleAdd}
          endIcon={<AddIcon />}
          disabled={emails.length === 0}
          sx={{
            minWidth: { xs: '100%', sm: '120px' },
            whiteSpace: 'nowrap',
          }}
        >
          Add
        </Button>
      </Box>
    </Paper>
  );
};

export default AddRecipientForm;
